import React from 'react';
import PropTypes from 'prop-types';

import SeatMap from '@weezevent/throne';

import ThroneSeatElements from '../../../../pages/placement/throne-seat-elements';

import Attendee from '../../../../models/attendeeModel';

import AttendeeHover from './attendee-hover';

import { SeatMapBackButton } from '../../../placement/seatmap-back-button';

function SelectedStyles({ selectedAttendees }) {
    let style = selectedAttendees.map(({ booking: { seat_uuid } }) => {
        return `
            td.seatmap-seat[data-seat-id="${seat_uuid}"] svg path {
                fill: #0032fa;
            }
        `;
    });

    return <style>{style.join('\n')}</style>;
}

SelectedStyles.propTypes = {
    selectedAttendees: PropTypes.array.isRequired
};

export default function SeatMapSelector({ availability, selectedAttendees, deselectAttendees = () => {}, selectAttendees = () => {}, onBack = () => {} }) {
    const [hover, setHover] = React.useState(null);
    let zone = { ...availability };

    zone.seats.forEach(seat => {
        seat.state = seat.booking_state.toLowerCase();
    });

    const get_attendee = seat => {
        let attendee = new Attendee(seat.active_booking.attendee);
        attendee.createBooking(seat.active_booking);
        return attendee;
    };

    const onSeatOver = React.useCallback(seat => {
        if (!seat?.active_booking?.attendee) {
            setHover(null);
            return;
        }

        let attendee = get_attendee(seat);
        setHover({ attendee, seat });
    });

    const _selectAttendees = React.useCallback(
        seats => {
            // Check if at least one new seat is selected
            let find = seat => selectedAttendees.find(({ booking: { seat_uuid } }) => seat_uuid === seat.uuid);
            let some_selection = seats.some(find) && !seats.every(find);
            let nothing_selected = seats.every(seat => !find(seat));
            let booked_seats = seats.filter(seat => Boolean(seat.active_booking?.attendee));
            let attendees = booked_seats.map(seat => get_attendee(seat)).filter(a => a);

            if (some_selection || nothing_selected) {
                selectAttendees(attendees);
            } else {
                deselectAttendees(attendees);
            }
        },
        [selectAttendees]
    );

    return (
        <React.Fragment>
            <AttendeeHover attendee={hover?.attendee} seat={hover?.seat} />
            <SelectedStyles selectedAttendees={selectedAttendees} />
            <SeatMapBackButton name={availability.name} onBack={onBack} />
            <SeatMap
                showScene={false}
                showPopup={false}
                minimap={false}
                zone={zone}
                onSeatOver={onSeatOver}
                onSeatsSelected={_selectAttendees}
                onSeatClicked={seat => _selectAttendees([seat])}
                mapOptions={{
                    showRowNumbers: true,
                    zoomControls: false,
                    offset: false,
                    seatElements: ThroneSeatElements
                }}
            />
        </React.Fragment>
    );
}

SeatMapSelector.propTypes = {
    availability: PropTypes.object.isRequired,
    selectedAttendees: PropTypes.array.isRequired,
    selectAttendees: PropTypes.func.isRequired,
    deselectAttendees: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired
};
